import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import 'animate.css'
import scrollAnimation from './directives/scrollAnimation'
import Message from './components/message.js'
import { initializeCsrf } from './utils/csrf'
import { install as routerUtilsInstall } from './utils/router'

// 添加滚动动画的CSS样式
const style = document.createElement('style')
style.textContent = `
  .scroll-animation-hidden {
    opacity: 0;
    visibility: hidden;
  }
  .scroll-animation-visible {
    opacity: 1;
    visibility: visible;
  }
  
  /* 确保animate.css动画能正常工作 */
  .animate__animated {
    animation-duration: 1s;
    animation-fill-mode: both;
  }
`
document.head.appendChild(style)

// 注册滚动动画指令
Vue.directive('scroll-animation', scrollAnimation)

// 注册全局Message组件
Vue.prototype.$message = Message

// 注册路由工具
Vue.use(routerUtilsInstall)

Vue.config.productionTip = false

// 创建 Vue 实例
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

// 页面加载时检查并生成 CSRF token
initializeCsrf().catch(error => {
  console.warn('CSRF token 初始化失败，但应用将继续运行:', error.message)
})
